import { useLazyQuery } from '@apollo/client'
import React, { useState, useEffect } from 'react'
import { useParams } from 'react-router-dom'

import { FileStatus, ImageProps } from '../../components/UploadBox/ImageBox'
import { UploadBox } from '../../components/UploadBox/index'
import { PROVIDER_LOGO_QUERY } from '../../graphql/upload'
import { getRoleFromStorage } from '../../helpers/userData'
import providerPagesRoleManagement from '../../staticRoleManagement/providerRoleManagement'
import { Image } from '../../types/image'

export const UploadBoxForProviderLogo = () => {
  const [images, setImages] = useState<ImageProps[]>([])
  const params = useParams<{
    providerCode: string
    providerID: string
  }>()

  const [getImages, { data, loading }] = useLazyQuery<{
    providerLogo: Image
  }>(PROVIDER_LOGO_QUERY, {
    fetchPolicy: 'network-only'
  })

  useEffect(() => {
    getImages({
      variables: {
        providerCode: params.providerCode
      }
    })
  }, [])

  useEffect(() => {
    if (data) {
      let newImages: ImageProps[] = []

      newImages = [
        {
          fileURL: data.providerLogo.url,
          status: FileStatus.COMPLETED,
          fileName: data.providerLogo.name,
          fileSize: data.providerLogo.size,
          mediaID: data.providerLogo.id
        }
      ]

      setImages(newImages)
    }
  }, [loading, data])

  const hasAccessToUploadLogoForProvider = providerPagesRoleManagement
    .find((item) => item.route === '/provider/create')
    ?.rolesListWithWriteAccess?.includes(getRoleFromStorage())

  return (
    <>
      <UploadBox
        hasAccess={hasAccessToUploadLogoForProvider}
        loading={loading}
        entityCode={params.providerCode}
        entityid={params.providerID}
        entityType={'Provider'}
        images={images}
        setImages={setImages}
        imageType={'Logo'}
      />
    </>
  )
}
